import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Network } from '@ionic-native/network';
import { DataProvider } from '../data/data';
import { ConstantsProvider } from '../constants/constants';

/*
  Generated class for the CloudDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class CloudDataProvider {

   // private apiDomain: string = 'https://drive.chaintechdev.com/chains/web/'; // 速度快的开发环境
   // private apiDomain: string = 'https://uat-chains.ignitormedia.com/';
   private apiDomain: string = 'https://chains.ignitormedia.com/';
   private isConnected = false;


   /** ----- Constructor ----- **/

   constructor(private data: DataProvider,
      private constants: ConstantsProvider,
      private http: HttpClient,
      private network: Network) {

      // on network connected
      this.network.onConnect().subscribe(() => {

         this.isConnected = true;
      });


      // on network disconnected
      this.network.onDisconnect().subscribe(() => {

         this.isConnected = false;
      });

   }


   /** ----- Internal Methods ----- **/

   // checkNetwork() { console.log( this.network.type ); return this.network.type != null && this.network.type != 'none'; }
   checkNetwork() { return true; }


   packParams(inParams) {

      // get all keys of param list
      let data = new FormData();
      let str = '?';
      for (let key in inParams) {
         // pack params
         data.append(key, inParams[key]);
         str += key + '=' + inParams[key] + '&';
      }
      return [str.slice(0, str.length - 1), data, inParams];

   }


   /** ----- Account Managment ----- **/

   login = (inMode, inParams) => {

      return new Promise(resolve => {

         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to login
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + ((inMode == 0) ? 'account/phy-login' : 'account/admin-login') , data[1], {}).subscribe(res => {

               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }


   getSelf = (inMode) => {

      return new Promise(resolve => {

         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to get self info
            let params = {
               'token': this.data.token
            };
            let data = this.packParams(params);
            this.http.post(this.apiDomain + ((inMode == 0) ? 'get/phy-self' : 'get/admin-self') , data[1], {}).subscribe(res => {

               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }


   /** ----- Tickets ----- **/

   getTickets = (inMode, inParams) => {

      return new Promise(resolve => {

         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to logout
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + ((inMode == 0) ? 'get/phy-tickets' : 'get/disp-tickets') , data[1], {}).subscribe(res => {

               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }


   upsertTicketActive = (inParams) => {

      return new Promise(resolve => {

         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to logout
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + 'upsert/make-ticket-active' , data[1], {}).subscribe(res => {

               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   updateTicketActive = (inParams) => {

      return new Promise(resolve => {

         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to logout
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + 'upsert/admin-ticket' , data[1], {}).subscribe(res => {

               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   upsertPatient = (inParams) => {
      return new Promise((resolve) => {
         // handle response
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
        //this.apiDomain + "upsert/admin-patient"
            // try to update/insert patients' info
            let data = this.packParams(inParams);
            this.http
               .post(this.apiDomain + "upsert/admin-patient" , data[1], {})
               .subscribe(
                  (res) => {
                     // return response
                     resolve(res);
                  },
                  (err) => {
                     // return a 'network error' msg in callback
                     resolve({ status: false, result: "failed" });
                  }
               );
         } else {
            // return a 'network error' msg in callback
            resolve({ status: false, result: "network" });
         }
      });
   };

   saveConsultationAsPending = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + 'upsert/make-ticket-pending' , data[1], {}).subscribe(res => {
               resolve(res);
            },
               err => {
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   saveTicketAsDone = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + 'upsert/make-ticket-done' , data[1], {}).subscribe(res => {
               resolve(res);
            },
               err => {
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   getConsultations = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to logout
            let data = this.packParams(inParams);
            this.http.post(this.apiDomain + 'get/phy-consultations' , data[1], {}).subscribe(res => {
               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }


   /** ----- Items ----- **/

   getDispList = () => {

      return new Promise(resolve => {

         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // try to logout
            this.http.get(this.apiDomain + 'get/admin-disp-list', {}).subscribe(res => {

               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   getConsultationsHistory = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // actionPhyConsultationsHistory
            let data = this.packParams(inParams);
            // this.http.post( this.apiDomain + 'get/phy-consultations-history', data[ 0 ], data[ 1 ], {} ).subscribe( res => {
            this.http.post(this.apiDomain + 'get/phy-consultations-history' , data[1], {}).subscribe(res => {
               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   getConsultationsByPatids = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // actionPhyConsultationsHistory
            let data = this.packParams(inParams);
            // getConsultationListByPatId
            this.http.post(this.apiDomain + 'get/consultation-list-by-pat-ids' , data[1], {}).subscribe(res => {
               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   get1819rules = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // actionPhyConsultationsHistory
            let data = this.packParams(inParams);
            // getConsultationListByPatId
            this.http.post(this.apiDomain + 'get/1819rules' , data[1], {}).subscribe(res => {
               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   acuButtonClicked = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // actionPhyConsultationsHistory
            let data = this.packParams(inParams);
            // actionUpsertTicketAcuStart
            this.http.post(this.apiDomain + 'upsert/upsert-ticket-acu-start' , data[1], {}).subscribe(res => {
               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

   dispButtonClicked = (inParams) => {
      return new Promise(resolve => {
         // if network exists
         if (this.isConnected || this.checkNetwork()) {
            // actionPhyConsultationsHistory
            let data = this.packParams(inParams);
            // actionUpsertTicketAcuStart
            this.http.post(this.apiDomain + 'upsert/upsert-ticket-disp-start' , data[1], {}).subscribe(res => {
               // return response
               resolve(res);
            },
               err => {

                  // return a 'api failed' msg in callback
                  resolve({ 'status': false, 'result': 'failed' });
               });
         }
         else {
            // return a 'network error' msg in callback
            resolve({ 'status': false, 'result': 'network' });
         }
      });
   }

}



// WEBPACK FOOTER //
// ./src/providers/cloud-data/cloud-data.ts